import { testimonials } from '../../../mocks/products';

const WA_URL = 'https://wa.me/573228000501?text=Hola%2C%20quiero%20conocer%20m%C3%A1s%20sobre%20sus%20productos';

export default function Testimonials() {
  return (
    <section className="py-16 md:py-24 bg-gradient-to-b from-white to-amber-50/30">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Lo Que Dicen Nuestros Clientes
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Testimonios reales de nuestra comunidad que confía en nuestra boutique
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 max-w-7xl mx-auto">
          {testimonials.map((t) => (
            <div
              key={t.id}
              className="bg-white rounded-2xl p-6 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-amber-100"
            >
              <div className="flex flex-col items-center mb-4">
                <div className="relative mb-3">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-20 h-20 rounded-full object-cover border-4 border-amber-400"
                  />
                  <div className="absolute -bottom-1 -right-1 bg-amber-400 rounded-full p-1">
                    <i className="ri-double-quotes-l text-white text-xs" />
                  </div>
                </div>
                <h3 className="font-semibold text-gray-900 text-center">{t.name}</h3>
                <p className="text-sm text-gray-500">{t.location}</p>
              </div>
              <div className="flex items-center justify-center gap-1 mb-3">
                <span className="text-xs text-emerald-600 font-medium bg-emerald-50 px-3 py-1 rounded-full border border-emerald-200">
                  ✓ Compra verificada
                </span>
              </div>
              <div className="flex justify-center gap-1 mb-4">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-lg" />
                ))}
              </div>
              <p className="text-gray-700 text-sm leading-relaxed text-center">
                &ldquo;{t.review}&rdquo;
              </p>
            </div>
          ))}
        </div>

        {/* Footer CTA */}
        <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">Se uno de nuestros clientes satisfechos</p>
          <a
            href={WA_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-gradient-to-r from-amber-400 to-amber-500 text-white px-8 py-4 rounded-full font-semibold hover:from-amber-500 hover:to-amber-600 transition-all duration-300 hover:-translate-y-1 whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-2xl" />
            Escríbenos por WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
